'use strict';

var StrategyReadonlyAllocationAuthAvailActionsController = function StrategyReadonlyAllocationAuthAvailActionsController($scope) {
  $scope.filterOutEmptyActions = function (element) {
    return !element.isEmpty();
  };
};
StrategyReadonlyAllocationAuthAvailActionsController.$inject = ['$scope'];
module.exports = StrategyReadonlyAllocationAuthAvailActionsController;